// extracted by mini-css-extract-plugin
module.exports = {"headingDefaults":"_135IN","ellipsis":"_3ybWg"};